// Classic › schedule (#1119): the Schedule page and Classic's schedule,
// standings, bracket and division parts (also used on Home, Stats, Players
// and Teams). League words (statuses, formats, Matchday, All divisions, …)
// come from the labels layer.
import { select } from '../../../plural'

const en = {
  /** #583: beside the division status line, "12 games". */
  gameCount: (n: number, sport: string) =>
    select(sport, {
      soccer: n === 1 ? `${n} match` : `${n} matches`,
      other: n === 1 ? `${n} game` : `${n} games`,
    }),
  /** #583: one division picked, nothing scheduled yet. */
  divisionEmpty: (division: string) => `No ${division} games scheduled yet`,
  seeAllDivisions: 'See all divisions',
  venue: 'Venue',
  starts: 'Starts:',
  ends: 'Ends:',
  /** The division switcher's polite status line. */
  showing: (division: string) => `Showing ${division}`,
  showingAll: 'Showing all divisions',
  standings: {
    /** "{division or competition} Standings" */
    heading: (name: string) => `${name} Standings`,
    /** The table's caption for screen readers. */
    caption: (division: string, season: string | null) =>
      season ? `${division} standings, ${season}` : `${division} standings`,
    loadError: "Standings couldn't be loaded.",
    none: 'No standings available',
    team: 'Team',
    seed: 'Seed',
    wins: 'W',
    losses: 'L',
    status: 'Status',
    goTo: (name: string) => `Go to ${name}`,
    swipe: 'Swipe for more',
    previous: 'Previous standings',
    next: 'Next standings',
  },
  viewFullBracket: 'View full bracket →',
}

export default en
